import { Typography } from "@mui/material"

/**
 * Shared "no answer" presentation for the internal reviewer's read-only response values. A recipient
 * may leave any requested field blank, so every per-type value renderer (and the value host) shows the
 * same muted em dash when its value is empty. Kept in one import-light file so the placeholder text and
 * the emptiness rule stay consistent across all the type renderers and are unit-testable in isolation.
 */

/** The muted text shown when a requested field has no answer. */
export const EMPTY_VALUE_PLACEHOLDER = "—"

/**
 * Whether a raw response value should be treated as "no answer". `0` and `false` are intentionally NOT
 * empty (a number/choice field may legitimately hold them); only `null`, `undefined` and blank/
 * whitespace-only strings count as empty.
 *
 * @param {*} value
 * @returns {boolean}
 */
export function isEmptyValue(value) {
    if (value === null || value === undefined) return true
    if (typeof value === "string") return value.trim() === ""
    return false
}

/**
 * The muted placeholder element rendered in place of an absent value. Used by every per-type value
 * renderer so the empty state looks identical regardless of field type.
 */
export function EmptyValue() {
    return (
        <Typography variant="body2" color="text.disabled" component="span" data-cy="requested-field-value-empty">
            {EMPTY_VALUE_PLACEHOLDER}
        </Typography>
    )
}
